import { ReactNode } from "react";
import { PaletteProvider } from "./lib/palette";
import { ThemeProvider } from "./lib/theme";
import alpha from "color-alpha";
import { useMedia } from "use-media";

export function MainTheme({ children }: { children: ReactNode }) {
  const isDesktop = useMedia({ minWidth: "1440px" });

  return (
    <PaletteProvider>
      {(palette) => (
        <ThemeProvider
          theme={{
            cssVar: true,
            token: {
              colorPrimary: palette.primary[5],
              colorSuccess: palette.success[5],
              colorError: palette.error[5],
              controlItemBgHover: palette.neutral[3],
              colorSplit: palette.neutral[3],
              colorBorder: palette.neutral[3],
              colorTextPlaceholder: palette.neutral[6],
              colorTextHeading: palette.primary[9],
              colorText: palette.primary[9],
              colorLink: palette.primary[5],
              colorLinkHover: palette.primary[3],
            },
            components: {
              Collapse: {
                headerBg: palette.neutral[3],
              },
              Dropdown: {
                controlItemBgHover: palette.primary[0],
              },
              Layout: {
                bodyBg: alpha(palette.neutral[0], 0.4),
                siderBg: palette.neutral[0],
              },
              Menu: {
                itemHoverBg: palette.primary[0],
                itemHoverColor: palette.primary[5],
              },
              Card: {
                colorBorderSecondary: palette.neutral[3],
                paddingLG: isDesktop ? 24 : 18,
                fontWeightStrong: 500,
              },
              Button: {
                paddingInlineLG: 24,
              },
              Avatar: {
                colorTextPlaceholder: palette.primary[5],
              },
              Table: {
                headerBg: palette.neutral[1],
                headerSplitColor: palette.neutral[3],
              },
              Form: {
                colorTextPlaceholder: palette.neutral[3],
                labelColor: palette.primary[9],
              },
              Breadcrumb: {
                separatorColor: "white",
              },
              Divider: {
                colorSplit: palette.neutral[1],
              },
              Carousel: {
                dotHeight: "16px",
                dotWidth: "16px",
                dotActiveWidth: "16px",
                borderRadius: 50,
              },
            },
          }}
        >
          {children}
        </ThemeProvider>
      )}
    </PaletteProvider>
  );
}
